<template>
    <div class="TTL-main-box">

        <!-- 头部导航器 -->
        <div :class="isfullscreen ? 'TTL-main-box-nav TTL-main-box-nav-fullscreen' : 'TTL-main-box-nav' ">
            <div class="TTL-main-box-fullscreen">
            <div :class="isfullscreen ? 'TTL-button-fullscreen-cannel' : 'TTL-button-fullscreen' ">
            <el-tooltip class="item" effect="dark" :content="isfullscreen ? '点击取消全屏模式' : '点击进入全屏模式' " placement="top">
            <el-button @click="isfullscreen ? isfullscreen=false : isfullscreen=true" />
            </el-tooltip>
            </div>
            </div>

            <div class="TTL-main-box-nav-fresh">
            <div class="TTL-button-fresh">
            <el-tooltip class="item" effect="dark" content="点击刷新当前数据" placement="top">
            <el-button @click="freshLocaldata" />
            </el-tooltip>
            </div>
            </div>

            <el-tooltip class="item" effect="dark" content="点击选择要删除的数据" placement="top">
            <div class="TTL-nav-del-all" @click="delNavAll"></div>
            </el-tooltip>

            <el-tooltip class="item" effect="dark" content="点击删除当前所有窗口" placement="top">
            <div class="TTL-nav-label" @click="updatePagelabel"></div>
            </el-tooltip>

            <div class="TTL-main-nav-box">
                <div class="TTL-nav-prev" @click="prevNav"></div>
                <div class="TTL-nav-next" @click="nextNav"></div>
                <div class="TTL-nav-content">
                    <div class="TTL-nav-content-box">
                        <div class="TTL-nav-content-all">
                            <div v-for="(item,index) in navlabel" :key="index" 
                            :class="item.isshow ? 'TTL-nav-info TTL-nav-info-select' : 'TTL-nav-info'" 
                            @click="moveNav(index)">
                            {{item.name}}
                            <a @click.stop="NavDel(index)"></a>
                            <span></span>
                            <i></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 头部导航器 -->



        <!-- 左边菜单部分 -->
        <div :class="isfullscreen ? 'TTL-main-box-left TTL-main-box-left-fullscreen' : 'TTL-main-box-left' ">
            <div class="TTL-left-avar">
                <div class="TTL-left-avar-info">
                    <div class="TTL-left-avar-image" @click="ExitLogin">
                    <el-image :src="manager.avar ? manager.avar : require('@/assets/icon/member-default.png')" fit="cover" />
                    </div>
                    <div class="shopname top10" @click="showmanagers=true">
                        <span>{{manager.shopname}}</span>
                        <el-image :src="require('@/assets/icon/xiala.png')" />
                    </div>
                </div>
            </div>
            <div class="TTL-left-menu">
                <div v-for="(item,index) in menus" :key="index" :class="item.isshow ? 'TTL-left-menu-infos-style1' : 'TTL-left-menu-infos-style1 meus-close'">
                    <div class="parents" @click="showchild(index)">
                        <div class="goldan" v-if="item.isfree"><el-image :src="require('@/assets/icon/goldan.png')" /></div>
                        <el-image :src="item.icon" fit="cover" />
                        <span :title="item.name">{{item.name}}</span>
                    </div>
                    <div :class="child.isselect ? 'children active' : 'children'" v-for="(child,i) in item.children" :key="i" @click="moveMenu(child.components)">
                        <div class="goldan" v-if="child.isfree"><el-image :src="require('@/assets/icon/goldan.png')" /></div>
                        <span :title="child.name">{{child.name}}</span>
                    </div>
                </div>

            </div>
        </div>
        <!-- 左边菜单部分 -->



        <!-- 主体 -->
        <div :class="isfullscreen ? 'TTL-main-box-content TTL-main-box-content-fullscreen' : 'TTL-main-box-content' ">
            <div v-for="(item,index) in navlabel" :key="index" v-show="item.isshow" class="TTL-components" :id="item.components+'box'">
            <component :is="item.components" :ref="item.components" />
            </div>
        </div>
        <!-- 主体 -->

        
        <!-- 退出登录 -->
        <el-dialog v-model="showexitlogin" class="TTL-login-exit" width="25%">
            <span class="TTL-exit-title">您是否确定要退出当前账号？</span>
            <div class="TTL-exit-info top20">
                <el-image :src="manager.avar ? manager.avar : require('@/assets/icon/member-default.png')" fit="cover" />
                <span class="top10">{{manager.shopname}} ~ {{manager.username}}</span>
            </div>
            <div class="TTL-exit-btn top30">
                <div class="TTL-button">
                <el-button type="del" @click="showexitlogin=false">取消</el-button>
                </div>
                <div class="TTL-button">
                <el-button @click="sureexitlogin">确定</el-button>
                </div>
            </div>
        </el-dialog>


        <!-- 切换店铺 -->
        <el-dialog v-model="showmanagers" class="TTL-login-exit" width="35%">
            <span class="TTL-exit-title-left">切换管理员</span>
            <div class="TTL-manager-list top30">
                <div class="TTL-manager-list-info bottom30" v-for="(item,index) in managerlist" :key="index">
                    <wcimage :option="{size:'middle'}" :value="item.thumb" />
                    <span class="TTL-manager-name">{{item.shopname}}<i>（管理员：{{item.name}}）</i></span>
                    <div class="TTL-manager-btn">
                    <div class="TTL-button">
                    <el-button @click="changeManager(item)">切换</el-button>
                    </div>
                    </div>
                </div>
            </div>
        </el-dialog>


    </div>
</template>


<script>
import cookies from 'js-cookie';
import INTERFACE_MODEL_AUTHORITY from '@/Interface/manager/authority';
import INTERFACE_MODEL_LOGIN from '@/Interface/Login/login';
import Record from '@/views/Record/Record';                       //宠物记录
import RecordDetail from '@/views/Record/RecordDetail';           //宠物记录详情
import AddRecord from '@/views/Record/AddRecord';                 //新增宠物记录
import EditRecord from '@/views/Record/EditRecord';               //编辑宠物记录
import RecordType from '@/views/Record/RecordType';               //记录类型
import AddRecordType from '@/views/Record/AddRecordType';         //新增记录类型
import EditRecordType from '@/views/Record/EditRecordType';       //编辑记录类型
import Pet from '@/views/Pets/Pets';                              //宠物管理
import AddPet from '@/views/Pets/AddPet';                         //添加宠物
import EditPet from '@/views/Pets/EditPet';                       //添加宠物
import AddPetBreed from '@/views/Pets/AddPetBreed';               //宠物品种管理
import EditPetBreedMore from '@/views/Pets/EditPetBreedMore';     //批量修改宠物的品种
import EditPetSexMore from '@/views/Pets/EditPetSexMore';         //批量修改宠物的性别

import PetSchedule from '@/views/Pets/PetSchedule';               //宠物日程提醒管理
import AddPetSchedule from '@/views/Pets/AddPetSchedule';         //新增宠物日程提醒管理
import EditPetSchedule from '@/views/Pets/EditPetSchedule';       //修改宠物日程提醒管理

import ScheduleType from '@/views/Pets/ScheduleType';             //宠物日程提醒类型管理
import AddScheduleType from '@/views/Pets/AddScheduleType';       //宠物新增日程提醒类型
import EditScheduleType from '@/views/Pets/EditScheduleType';     //宠物编辑日程提醒类型

import Birth from '@/views/Pets/Birth';                           //宠物繁育
import AddBirth from '@/views/Pets/AddBirth';                     //新增宠物繁育
import EditBirth from '@/views/Pets/EditBirth';                   //编辑宠物繁育

import PetNest from '@/views/Pets/PetNest';                       //宠物窝次
import AddPetNest from '@/views/Pets/AddPetNest';                 //新增宠物窝次
import EditPetNest from '@/views/Pets/EditPetNest';               //编辑宠物窝次

import Member from '@/views/Member/Member';                       //会员管理
import AddMember from '@/views/Member/AddMember';                 //新增会员
import EditMember from '@/views/Member/EditMember';               //批量修改会员

import Banner from '@/views/Banner/Banner';                       //Banner信息
import AddBanner from '@/views/Banner/AddBanner';                 //新增Banner
import EditBanner from '@/views/Banner/EditBanner';               //编辑Banner
import Setting from '@/views/Setting/Setting';                    //基础设置
import Tdisk from '@/views/Setting/Tdisk';                        //文件空间管理
import SystemPhotos from '@/views/Setting/SystemPhotos';          //系统图集管理
import ShopPhotos from '@/views/Setting/ShopPhotos';              //商户图集管理
import Wechat from '@/views/Setting/Wechat';                      //小程序设置
import Manager from '@/views/Manager/Manager';                    //管理员
import AddManager from '@/views/Manager/AddManager';              //新增管理员
import EditManager from '@/views/Manager/EditManager';            //编辑管理员
import Home from '@/views/Home/Home';                             //家族族谱
import HomeMember from '@/views/Home/HomeMember';                 //家庭成员
import ImageVideo from '@/views/ImageVideo/ImageVideo';           //图像资料信息
import EditXcxPetCate from '@/views/Setting/EditXcxPetCate';      //基础设置

import PlatFormShop from '@/views/PlatFormShop/PlatFormShop';       //平台账号管理
import ShopFollow from '@/views/PlatFormShop/ShopFollow';           //商户跟进记录
import AddPlatFormShop from '@/views/PlatFormShop/AddPlatFormShop'; //平台新增账号
import EditPlatFormShop from '@/views/PlatFormShop/EditPlatFormShop'; //平台编辑账号
import platFormMenu from '@/views/PlatFormShop/PlatFormMenu';       //平台菜单信息
import PlatFormLevel from '@/views/PlatFormShop/PlatFormLevel';       //平台账号版本管理
import AddPlatFormLevel from '@/views/PlatFormShop/AddPlatFormLevel';  //平台账号新增版本
import EditPlatFormLevel from '@/views/PlatFormShop/EditPlatFormLevel'; //平台账号编辑版本
import SetPlatFormLevelAuth from '@/views/PlatFormShop/SetPlatFormLevelAuth'; //平台账号版本权限设置
import PlatFormCost from '@/views/PlatFormShop/PlatFormCost';           //平台账号功能续费
import AddPlatFormReNew from '@/views/PlatFormShop/AddPlatFormReNew';   //平台账号新增功能续费

import PlatFormCostSetting from '@/views/PlatFormShop/PlatFormCostSetting';   //平台账号功能续费设置
import AddPlatFormCostSetting from '@/views/PlatFormShop/AddPlatFormCostSetting'; //新增平台续费设置
import EditPlatFormCostSetting from '@/views/PlatFormShop/EditPlatFormCostSetting'; //编辑平台续费设置

import PlatFormSetting from '@/views/PlatFormShop/PlatFormSetting';     //平台账号设置管理
import PlatFormSettingNew from '@/views/PlatFormShop/PlatFormSettingNew'; //设置管理
import PlatSuperLog from '@/views/PlatFormShop/PlatSuperLog';           //平台超级日志
import PlatFormVideo from '@/views/PlatFormShop/PlatFormVideo';         //平台教程管理
import PlatFormVideoCate from '@/views/PlatFormShop/PlatFormVideoCate'; //平台教程分类管理
import AddPlatFormVideoCate from '@/views/PlatFormShop/AddPlatFormVideoCate'; //新增平台教程分类管理
import EditPlatFormVideoCate from '@/views/PlatFormShop/EditPlatFormVideoCate'; //编辑平台教程分类管理
import AddPlatFormVideo from '@/views/PlatFormShop/AddPlatFormVideo'; //新增平台教程
import EditPlatFormVideo from '@/views/PlatFormShop/EditPlatFormVideo'; //编辑平台教程

import EsIndex from '@/views/EsIndex/Index';  //首页

import EsGoods from '@/views/EsGoods/Goods';  //商品信息
import EsAddGoods from '@/views/EsGoods/Module/AddGoods';  //新增商品信息
import EsEditGoods from '@/views/EsGoods/Module/EditGoods';  //编辑商品信息
import EsGoodsDetail from '@/views/EsGoods/GoodsDetail';  //商品详情
import EsFrozen from '@/views/EsFrozen/Frozen';  //商品冻结记录
import EsFrozenDetail from '@/views/EsFrozen/FrozenDetail';  //举报记录详情
import EsComment from '@/views/EsGoods/Comment';  //商品评论
import EsLetter from '@/views/EsGoods/Letter';  //私信

import EsCates from '@/views/EsCates/Cates';  //分类信息
import EsAddCates from '@/views/EsCates/Module/AddCates';  //新增分类
import EsEditCates from '@/views/EsCates/Module/EditCates';  //编辑分类
import EsMembers from '@/views/EsMembers/Members';  //会员信息
import ESAuthLog from '@/views/EsMembers/AuthLog';  //会员认证审核记录
import EsAddMember from '@/views/EsMembers/Module/AddMember';  //添加会员信息
import EsEditMember from '@/views/EsMembers/Module/EditMember';  //编辑会员信息
import EsMemberDetail from '@/views/EsMembers/MemberDetail';  //会员详情信息
import EsVip from '@/views/EsMembers/Vip';  //会员vip管理
import EsAddVip from '@/views/EsMembers/Module/AddVip';  //新增vip
import EsEditVip from '@/views/EsMembers/Module/EditVip';  //编辑vip
import EsVipDetail from '@/views/EsMembers/VipDetail';  //vip详情信息

import EsFrozenMember from '@/views/EsMembers/Module/FrozenMember';  //冻结会员
import EsUnFrozenMember from '@/views/EsMembers/Module/UnFrozenMember';  //解冻会员
import EsStatoperates from '@/views/EsStat/Statoperates';  //运营数据分析
import EsStatoperateDetail from '@/views/EsStat/StatoperateDetail';  //运营数据分析详情
import EsStatHits from '@/views/EsStat/StatHits';  //商品点击统计

import EsCateStat from '@/views/EsStat/CateStat';  //分类数据统计
import EsXcxIndex from '@/views/EsXcx/XcxIndex';  //小程序首页设置

import EsRenew from '@/views/EsSetting/Renew';  //续费设置
import EsAddRenew from '@/views/EsSetting/Module/AddRenew';  //新增续费设置
import EsEditRenew from '@/views/EsSetting/Module/EditRenew';  //编辑续费设置
import EsRenewDetail from '@/views/EsSetting/Module/RenewDetail';  //续费设置详情
import EsPayment from '@/views/EsSetting/Payment';  //支付方式
import EsPaymentDetail from '@/views/EsSetting/Module/PaymentDetail';  //支付详情
import EsShipping from '@/views/EsSetting/Shipping';  //运费设置
import EsAddShipping from '@/views/EsSetting/Module/AddShipping';  //新增运费设置
import EsEditShipping from '@/views/EsSetting/Module/EditShipping';  //编辑运费设置
import EsEditSetting from '@/views/EsSetting/EditSetting';  //修改系统设置
import EsXcxGzhSetting from '@/views/EsSetting/EsXcxGzhSetting';    //小程序、公众号设置
import EsAutoPrice from '@/views/EsSetting/EsAutoPrice';    //会员续费认证
import AddEsAutoPrice from '@/views/EsSetting/Module/AddEsAutoPrice';    //新增会员续费认证
import EsEditAutoPrice from '@/views/EsSetting/Module/EsEditAutoPrice';    //编辑会员续费认证
import EsSysIcon from '@/views/EsSetting/EsSysIcon';   //系统图标设置
import EsEditAuth from '@/views/EsMembers/Module/EditAuth';                //编辑会员认证
import EsCash from '@/views/EsSetting/EsCash';    //查看红包设置记录
import AddCash from '@/views/EsSetting/Module/AddCash';    //新增红包设置
import EditCash from '@/views/EsSetting/Module/EditCash';    //编辑红包设置
import CashDetail from '@/views/EsSetting/Module/CashDetail';    //红包设置详情

import EsOrder from '@/views/EsOrder/Order';  //订单信息
import EsOrderDetail from '@/views/EsOrder/OrderDetail';  //订单详情

import EsTutarialCate from '@/views/EsTutarial/TutarialCate';  //使用教程分类
import EsAddTutarialCates from '@/views/EsTutarial/AddTutarialCates';  //新增教程分类
import EsEditTutarialCates from '@/views/EsTutarial/EditTutarialCates';  //编辑教程分类
import EsTutarial from '@/views/EsTutarial/Tutarial';  //使用教程
import EsAddTutarial from '@/views/EsTutarial/AddTutarial';  //新增使用教程
import EsEditTutarial from '@/views/EsTutarial/EditTutarial';  //编辑使用教程
import EsPromotion from '@/views/EsTutarial/EsPromotion';  //自媒体平台信息推广
import EsAddPromotion from '@/views/EsTutarial/EsAddPromotion';  //新增推广信息
import EsEditPromotion from '@/views/EsTutarial/EsEditPromotion';  //编辑推广信息



import EsWallet from '@/views/EsWallet/Wallet';  //提现管理

export default {
    components:{
        Pet,AddPet,EditPet,AddPetBreed,EditPetBreedMore,EditPetSexMore,
        PetSchedule,AddPetSchedule,EditPetSchedule,ScheduleType,AddScheduleType,EditScheduleType,Birth,AddBirth,EditBirth,PetNest,AddPetNest,EditPetNest,
        Member,AddMember,EditMember,EsVip,EsAddVip,EsEditVip,EsVipDetail,
        Record,RecordType,AddRecordType,EditRecordType,AddRecord,RecordDetail,EditRecord,
        Banner,AddBanner,EditBanner,
        Setting,Wechat,Tdisk,SystemPhotos,ShopPhotos,EditXcxPetCate,
        Manager,AddManager,EditManager,
        Home,HomeMember,ImageVideo,
        PlatFormShop,ShopFollow,AddPlatFormShop,EditPlatFormShop,platFormMenu,PlatFormLevel,
        AddPlatFormLevel,EditPlatFormLevel,SetPlatFormLevelAuth,PlatFormCost,AddPlatFormReNew,PlatFormSetting,PlatFormSettingNew,
        PlatFormCostSetting,AddPlatFormCostSetting,EditPlatFormCostSetting,PlatSuperLog,PlatFormVideo,PlatFormVideoCate,AddPlatFormVideoCate,EditPlatFormVideoCate,
        AddPlatFormVideo,EditPlatFormVideo,
        EsIndex,EsOrder,EsOrderDetail,
        EsGoods,EsGoodsDetail,EsAddGoods,EsEditGoods,
        EsFrozen,EsFrozenDetail,EsComment,EsLetter,
        EsCates,EsAddCates,EsAddCates,EsEditCates,
        EsMembers,EsAddMember,EsEditMember,EsMemberDetail,EsFrozenMember,EsUnFrozenMember,ESAuthLog,EsEditAuth,EsCash,AddCash,EditCash,CashDetail,
        EsStatoperates,EsStatoperateDetail,EsCateStat,EsXcxIndex,EsStatHits,
        EsRenew,EsAddRenew,EsEditRenew,EsRenewDetail,EsPayment,EsPaymentDetail,
        EsShipping,EsAddShipping,EsEditShipping,EsEditSetting,EsXcxGzhSetting,EsAutoPrice,AddEsAutoPrice,EsEditAutoPrice,EsTutarialCate,EsAddTutarialCates,EsEditTutarialCates,EsTutarial,EsAddTutarial,EsEditTutarial,EsSysIcon,EsPromotion,EsAddPromotion,EsEditPromotion,
        EsWallet
    },
    data() {
        return {
            manager: {
              id:'',
              shopid:'',
              shopname:'',
              groupid:'',
              username:'',
              phone: '',
              avar: '',
              token:'',
            },
            menus: [
                {id:1,name:'宠物管理',icon:'',labelentry:'nav-宠物管理-1',components:'index',isshow:false},
                {id:2,name:'档案管理',icon:'',labelentry:'nav-档案管理-2',components:'files',isshow:false},
                {id:3,name:'系统设置',icon:'',labelentry:'nav-系统设置-3',components:'setting',isshow:false},
            ],
            navlabel: [],
            showexitlogin:false,
            menusauths:{},
            isfullscreen:false,
            managerlist:JSON.parse(localStorage.getItem('managerlists')),
            showmanagers:false,

        }
    },

    mounted() {
        var token=cookies.get('token'); //提取token信息，判断是否已登录
        if(token==undefined || token=='') {this.$router.push('/login');return false;} //未登录时跳转登录界面

        this.CheckLogin();      //检查当前是否为已登录
        this.PreloadBaseData(); //解析加载基础数据
    },

    methods: {


        /** 点击刷新加载当前页面数据 **/
        freshLocaldata() {
            //获取当前正在打开的窗口信息
            var component='';
            for(var i=0;i < this.navlabel.length;i++) this.navlabel[i].isshow ? component=this.navlabel[i].components : '';
            if(!component) {
                this.$notify({title:'错误提示',message:'当前没有正在显示的页面，请先选择正在显示的页面',type:'warning'});
                return false;
            }

            //开启窗口
            this.$loading.open();
            //刷新预加载数据
            var freshobj=this.$refs[component];
            freshobj[0].OnloadMethod(true);

            //延时关闭窗口
            var _this=this;
            setTimeout(function() {
                _this.$loading.close();
            },1000);
        },


        /** 查看当前页面的标签信息 **/
        updatePagelabel() {
            //获取当前正在打开的窗口信息
            var component='';
            for(var i=0;i < this.navlabel.length;i++) this.navlabel[i].isshow ? component=this.navlabel[i].components : '';
            if(!component) {
                this.$notify({title:'错误提示',message:'当前没有正在显示的页面，请先选择正在显示的页面',type:'warning'});
                return false;
            }
            //刷新预加载数据
            var freshobj=this.$refs[component];
            freshobj[0].ChangePageLabel(true);
        },


        /** 解析加载基础数据 **/
        PreloadBaseData() {
            var data=localStorage.getItem('managers');
            data=JSON.parse(data);
            this.manager.id=data.id;
            this.manager.shopid=data.shopid;
            this.manager.shopname=data.shop.shopname;
            this.manager.groupid=data.groupid;
            this.manager.username=data.name;
            this.manager.phone=data.phone;
            this.manager.avar=data.thumb;
            this.manager.token=cookies.get('token');
        },

        
        /** 检查当前是否已登录 **/
        CheckLogin() {
            this.$loading.open(); //开启loading加载等待动画
            INTERFACE_MODEL_LOGIN.MANAGER_LOGIN_CHECK({token:this.manager.token}).then((res) => {
                 if(res.status > 0) { //未登录或登录过期时
                     this.$loading.close();
                     this.$router.push('/login');
                     return false;
                 }
                 this.getsysmenu(); //检查成功，获取菜单信息
             });

        },


        /** 获取菜单信息 **/
        getsysmenu() {
            var param={managerid:this.manager.id,shopid:this.manager.shopid,groupid:this.manager.groupid,level:localStorage.getItem('level')};
            INTERFACE_MODEL_AUTHORITY.GET_MANAGER_AUTH(param).then((res) => {
                 this.$loading.close();
                 //未登录或登录过期时
                 if(res.status > 0) {this.$router.push('/login');return false;}
                 //存储功能使用权限
                 this.SaveMenuAuth(res.data);
                 
                 //组装调整数据
                 this.menus=res.data;
                 for(var i=0;i < this.menus.length;i++) this.menus[i].icon=require("@/assets/system/"+this.menus[i].icon+".png");
                 //默认选中第一个菜单
                 if(this.menus.length > 0) this.moveMenu(this.menus[0].children[0].components); 
            });
        },


        //////////////////////////////////////////////////
        //////////////////////////////////////////////////
        //nav标签操作

        //存储功能使用权限
        SaveMenuAuth(data) {
            this.menusauths={};
            //执行存储功能操作
            this.SaveMenuAuthHandle(data);
            //保存接口操作权限到浏览器
            localStorage.setItem('InterfaceAuth',JSON.stringify(this.menusauths)); 
            console.log(this.menusauths);
        },  

        //存储功能使用权限操作
        SaveMenuAuthHandle(data) {
            var obj;
            var auth_name='';
            var authlist=[];
            var child=[];
            for(var key in data) {
                obj=data[key]; //提取当前key
                if(obj && obj.action && obj.action!='') {
                    
                    //一个功能下可能包含有多个接口，全部上权限验证
                    authlist=obj.action.split('|'); 
                    for(var kk in authlist) {
                        auth_name=authlist[kk].trim();
                        if(auth_name!='') this.menusauths[auth_name]={isfree:obj.isfree,expiretime:obj.expiretime};
                    }
                    child=obj.children;
                    if(child.length > 0) this.SaveMenuAuthHandle(child);
                }
            }
        },


        /** 展开/收缩子菜单 **/
        showchild(index) {
            for(var i=0;i<this.menus.length;i++) {
                if(i==index) {
                    this.menus[i].isshow ? this.menus[i].isshow=false : this.menus[i].isshow=true;
                }else {
                    this.menus[i].isshow=false;
                }
            }
        },

        /** 上一个操作 **/
        prevNav() {
            this.$navigation.prev();
        },

        /** 下一个操作 **/
        nextNav() {
            this.$navigation.next();
        },


        /** 菜单选择-根据组件菜单选择子菜单 **/
        moveMenu(component) {

            //执行选中子菜单操作
            var result=this.moveMenuHandle(component);
            var labelentry=result.labelentry;
            var menuinfos=result.menuinfos;

            //检测label里是否有该标签
            var isexit=false;
            var navindex=-1;
            for(var i=0;i< this.navlabel.length; i++) 
            if(this.navlabel[i].labelentry==labelentry) {isexit=true;navindex=i;}

            //检nav是否存在，存在则直接勾选处理
            if(isexit) {this.moveNav(navindex);return false;}

            //不存在，执行新增nav
            var list={name:menuinfos.name,labelentry:menuinfos.labelentry,components:menuinfos.components,isshow:false};
            this.addNav(list);
        },


        /** 点击触发选择标签 **/
        moveNav(index) {
            //检查label是否存在，如果不存在则不往下执行
            if(!this.navlabel[index]) return false;

            //处理导航label选项
            var _this=this;
            var labelentry=''; //确认标识
            for(var i=0;i < this.navlabel.length; i++) {
                if(index==i) {
                    labelentry=this.navlabel[i].labelentry; //label取出导航标识
                    this.navlabel[i].isshow=true;           //label标记选中
                }else {
                    this.navlabel[i].isshow=false; //label标记不选中
                }
            }

            setTimeout(function() {
                _this.$navigation.moveNav(index); //对label 进行样式显示调整
                var component='';
                for(var i=0;i < _this.navlabel.length; i++) {
                    component=_this.navlabel[i].components+"box";
                    index==i ? 
                    document.getElementById(component).style.opacity=1 :
                    document.getElementById(component).style.opacity=0;
                }
            },200);

            this.moveMenuHandle(labelentry);
        },

        //删除当前标签
        NavDel(index) {
            //检测当前删除的label是否是已选中的label
            var selectnavindex=-1;
            for(var i=0;i < this.navlabel.length;i++) 
            this.navlabel[i].isshow ? selectnavindex=i : '';

            if(selectnavindex!==index) {
                this.navlabel.splice(index,1); //删除标签
                return false;
            }else {
                this.navlabel.splice(index,1); //删除标签
                var prev=index-1;
                var next=index;
                var showindex=-1;
                this.navlabel[prev] ?  showindex=prev : showindex=next;
                this.moveNav(showindex); //点击选中标签
            }
        },

        /** 删除全部标签 **/
        delNavAll() {
            this.$confirm.confirm(
                '您是否确定要清空当前全部导航条 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                this.navlabel=[]; //清空标签
                for(var i=0;i<this.menus.length;i++) this.menus[i].isshow=false; //取消所有已选中的菜单
                this.$navigation.moveReset(); 
            }).catch(()=> {

            });
        },

        /** 新增nav标签操作 **/
        addNav(data) {
            this.navlabel.push(data); //执行新增操作
            var num=this.navlabel.length-1;
            this.moveNav(num);
        },




        /** 点击选中子菜单具体操作（样式操作） **/
        moveMenuHandle(component) {
            var menuinfos;      //符合要求的菜单
            var labelentry='';  //菜单组件唯一标识识别
            var tempmeus;       //临时菜单信息
            var tempchildmenus; //临时子集菜单信息
            var historymenushow; //历史展开的父级菜单
            var historymeusselect; //历史选中的菜单

            for(var i=0;i<this.menus.length;i++) {
                tempmeus=this.menus[i];
                tempmeus.isshow ? historymenushow=i : '';
                tempmeus.isshow=false; //所有菜单展开选项
                if(tempmeus.children.length > 0) {
                    for(var ii=0;ii<tempmeus.children.length;ii++) {
                        tempchildmenus=tempmeus.children[ii];
                        tempchildmenus.isselect ? historymeusselect=ii : '';
                        tempchildmenus.isselect=false; //取消所有菜单选项
                        if(tempchildmenus.components==component) { //查到有匹配的数据时
                            menuinfos=tempchildmenus;       //提取目标菜单
                            tempmeus.isshow=true;          //父级菜单展开子菜单
                            tempchildmenus.isselect=true;   //子菜单标注选中
                            labelentry=tempchildmenus.labelentry; //提取组件唯一标识
                        }
                    }
                }
            }
            return {'labelentry':labelentry,'menuinfos':menuinfos};
        },


        //nav标签操作
        //////////////////////////////////////////////////
        //////////////////////////////////////////////////


        /////////////////////////////////////////////////
        /////////////////////////////////////////////////
        //子组件调用父组件执行操作

        /** 设置管理内嵌页的返回，回到对应 Tab **/
        RedirectSettingReturn(item) {
            var nested={
                PlatFormCostSetting:1,
                PlatFormSetting:2,
                Banner:3,
                ScheduleType:4,
                RecordType:5,
                PlatSuperLog:6,
                EsTutarial:7,
                EsTutarialCate:7
            };
            var target=item && item.nav ? item.nav.components : '';
            if(!target || !nested[target]) return item;

            var settingNav=null;
            for(var i=0;i<this.navlabel.length;i++) {
                if(this.navlabel[i].components=='PlatFormSettingNew') {
                    settingNav=this.navlabel[i];
                    break;
                }
            }
            if(!settingNav) return item;

            item.nav={
                name:settingNav.name,
                labelentry:settingNav.labelentry,
                components:'PlatFormSettingNew',
                isshow:false
            };
            item.data=item.data || {};
            item.data.param=Object.assign({}, item.data.param || {}, {
                tabComponent:target,
                activeTab:nested[target]
            });
            return item;
        },

        /** 新增/刷新子组件 **/
        ChildCompententAdd(item) {
            item=this.RedirectSettingReturn(item);
            var _this=this;
            var nav=item.nav;                        //拆解提取新增标签
            var data=item.data;                      //拆解提取加载数据
            if(data.delcomponents)                   //如果有标签需要删除的则执行删除标签操作
            this.DelNav(data.delcomponents);                  

            //检测当前标签是否已存在
            var isexit=false;
            var navindex=-1;
            for(var i=0;i< this.navlabel.length; i++) 
            if(this.navlabel[i].labelentry==nav.labelentry) {isexit=true;navindex=i;}

            //检nav是否存在
            if(isexit) { //已存在，做点击显示处理
                this.moveNav(navindex);
                data.isask=true; //点击加载前是否询问
            }else { //不存在，进行新增处理
                this.addNav(nav);
            }

            //调用子组件方法传递参数，用于子组件调用平级子组件方法传递参数，此处只是作为一个媒介进行兄弟组件的链接
            setTimeout(function() {
                var navobj=_this.$refs[nav.components][0];
                navobj.BrotherComponentIn(data);
            },300);
        },


        /** 删除组件标签 **/
        DelNav(component) {
            var delindex=-1;
            for(var i=0;i < this.navlabel.length;i++) 
            this.navlabel[i].components==component ? delindex=i : '';
            this.navlabel.splice(delindex,1);
        },


        /** 退出登录 **/
        ExitLogin() {
            this.showexitlogin=true;
        },


        /** 退出登录操作 **/
        sureexitlogin() {
            //清空浏览器缓存信息
            cookies.set('token',''); //设置token
            localStorage.setItem('managers',''); //存储管理员信息
            localStorage.setItem('shops',''); //存储管理员信息
            localStorage.setItem('shopid',''); //存储店铺id
            localStorage.setItem('managerid',''); //存储管理员id
            localStorage.setItem('groupid',''); //存储角色id   
            this.$router.push('/login');
            this.$notice({title:'消息提示',message:'操作成功',type:'success'});
        },


        /** 切换登录管理员 **/
        changeManager(item) {
            INTERFACE_MODEL_LOGIN.LOGIN({id:item.id,shopid:item.shopid}).then((res) => {
                if(res.status > 0) return false;
                res=res.data;
                cookies.set('token',res.token ? res.token : ''); //设置token
                localStorage.setItem('managerlists',JSON.stringify(this.managerlist)); //存储管理员信息
                localStorage.setItem('managers',JSON.stringify(res)); //存储管理员信息
                localStorage.setItem('shops',JSON.stringify(res.shop)); //存储管理员信息
                localStorage.setItem('shopid',res.shop.id); //存储店铺id
                localStorage.setItem('managerid',res.id); //存储管理员id
                localStorage.setItem('groupid',res.groupid); //存储角色id   
                localStorage.setItem('level',res.shop.level); //存储角色id   
                window.location.reload();
            });
        },

        //子组件调用父组件执行操作
        /////////////////////////////////////////////////
        /////////////////////////////////////////////////


        /**
         * 子组件跳转父组件信息
         * @param name string 跳转组件label
         * @param delname string 删除组件label
         * @param param obj 跳转携带参数
        */
        JUMPVIEW(data) {
            if(!data || !data.name || data.name=='') return false;     //参数不完善，放弃跳转
            var jumpobj=this.$JUMPMethod.TRANSLATE_JUMP(data.name);    //解析跳转参数
            if(jumpobj.label=='') return false;                        //解析跳转标签失败时，不跳转
            var delobj=this.$JUMPMethod.TRANSLATE_JUMP(data.delname);  //解析删除参数
            
            var navinfo={name:jumpobj.name,labelentry:jumpobj.label,components:jumpobj.label,isshow:false};
            var jumpdata={Method:'',delcomponents:delobj.label,param:data.param ? data.param : {}};
            var obj={nav:navinfo,data:jumpdata};
            this.ChildCompententAdd(obj);
        },

    },

}
</script>
<style scoped>
.shopname {width:auto;padding:5px 40px 5px 20px;border-radius: 20px;background-color: #3f3f40;display:inline-flex;align-items: center;position: relative;cursor: pointer;}
.shopname span {width:100%;display:inline-block;font-size: 12px;}
.shopname .el-image {width:10px;height: 10px;position: absolute;right:0;margin-right:20px;}
.TTL-main-box-left-fullscreen {margin-left:-200px;}
.TTL-main-box-nav-fullscreen {width:100%;margin-left:0;}
.TTL-main-box-content-fullscreen {width:calc(100% - 40px - 20px);margin-left:10px;}
.TTL-exit-title-left {text-align: left;font-size:14px;letter-spacing: 1px;}
.TTL-manager-list {display:inline-block;width:100%}
.TTL-manager-list-info {display:inline-flex;align-items: center;width:100%;margin-bottom:20px;}
.TTL-manager-name {width:50%;margin-left:20px;font-size:13px;}
.TTL-manager-name i {font-style:normal;font-size:12px;color:#999999;}
.TTL-manager-btn {width:calc(50% - 50px - 20px);text-align: right;}
</style>